var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V36C42 39.3137 39.3137 42 36 42H6C2.68629 42 0 39.3137 0 36V6Z",
    fill: "#EEEDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0427 25.0449C28.8563 25.4148 29.0051 25.8657 29.375 26.0521C29.7449 26.2385 30.1959 26.0897 30.3823 25.7198L29.0427 25.0449ZM16.2808 11.6183C15.9109 11.8047 15.7621 12.2556 15.9484 12.6255C16.1348 12.9954 16.5858 13.1442 16.9557 12.9579L16.2808 11.6183ZM14.6329 14.6396C14.9282 14.3491 14.9322 13.8743 14.6418 13.5789C14.3513 13.2836 13.8765 13.2797 13.5811 13.5701L14.6329 14.6396ZM28.427 28.4218C28.7175 28.1266 28.7137 27.6517 28.4185 27.3611C28.1233 27.0706 27.6485 27.0744 27.3579 27.3696L28.427 28.4218ZM30.3823 25.7198C32.4211 21.673 31.6339 16.7749 28.4298 13.5708L27.3691 14.6314C30.1155 17.3778 30.7903 21.5762 29.0427 25.0449L30.3823 25.7198ZM28.4298 13.5708C25.2257 10.3666 20.3275 9.57945 16.2808 11.6183L16.9557 12.9579C20.4243 11.2103 24.6227 11.885 27.3691 14.6314L28.4298 13.5708ZM13.5811 13.5701C10.892 16.2147 9.82793 20.0985 10.7935 23.7444L12.2435 23.3604C11.4159 20.2353 12.328 16.9064 14.6329 14.6396L13.5811 13.5701ZM10.7935 23.7444C11.7591 27.3904 14.6059 30.2384 18.2515 31.2054L18.6361 29.7555C15.5113 28.9267 13.0711 26.4855 12.2435 23.3604L10.7935 23.7444ZM18.2515 31.2054C21.8971 32.1724 25.7813 31.1098 28.427 28.4218L27.3579 27.3696C25.0902 29.6736 21.7609 30.5844 18.6361 29.7555L18.2515 31.2054Z",
    fill: "#2F2B3D",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25L30.75 30.75",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.cbc1f3b215958d5f4599724352a2f3cb.svg";
export { ForwardRef as ReactComponent };